// The feature's name as people see it. Code, data and analytics keep
// "auto publish" (the `auto-publish` flag, `auto_publish` columns).
export const AUTO_POST = "Auto post";
